<style>
    .login-or{
        line-height: 1px;
        background-color: #eee;
        text-align: center;
    }
    .login-or > span{
        display: inline-block;
        padding: 0 3px;
        color: #ccc;
        background-color: #fff;
    }
</style>
<template>
    <div class="login-or">
        <span>{{txt}}</span>
    </div>
</template>
<script>
    export default {
        name: 'LyLine',
        props: ['txt']
    }
</script>